module.exports = __webpack_public_path__ + "static/media/credit_card.330fe6e0.png";